import React from "react";
import { Outlet } from "react-router-dom";
import { NavBar } from "../components/NavBar";

const RootLayout = () => {
  return (
    <div>
      <NavBar />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default RootLayout;
